export default __webpack_public_path__ + "static/media/transfacil_galery_15.d46c8457.jpg";